import { Injectable } from '@angular/core';
import {APIService} from "./api.service";
import {SearchDescription} from "../interfaces/searchDescription";

@Injectable({
  providedIn: 'root'
})
export class SearchService extends APIService{

  public async getDescription(target: string, options: object = null): Promise<SearchDescription>{
    return await this.post<object, SearchDescription>('/search/describe/' + target, {
      options
    });
  }

  public async search(target: string, filters: any, sort: any = null, page:number = 1){
    return await this.post<any, any>('/search/' + target, {
      filter: filters,
      sort: sort,
      page: page
    });
  }
}
